import './CommercialCTA.css';
import savesUnderline from '../../assets/figma_saves_underline.svg';

export default function CommercialCTA() {
  return (
    <section className="ccta-section">
      <div className="ccta-inner">

        {/* Left */}
        <div className="ccta-left">
          <h2 className="ccta-title">
            Ready to Explore Commercial<br />
            <span className="ccta-title-accent">
              Battery Storage?
              <img src={savesUnderline} alt="" className="ccta-accent-stroke" />
            </span>
          </h2>
          <div className="ccta-underline" />
          <p className="ccta-desc">
            Speak with our team to understand whether battery storage is suitable for your business and how it could support your long-term energy strategy.
          </p>

          <div className="ccta-buttons">
            <a href="/contact" className="ccta-btn">
              <div className="ccta-btn-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="4" width="18" height="18" rx="3" stroke="#050b14" strokeWidth="1.8" />
                  <line x1="3" y1="9" x2="21" y2="9" stroke="#050b14" strokeWidth="1.8" />
                  <line x1="8" y1="2" x2="8" y2="6" stroke="#050b14" strokeWidth="1.8" strokeLinecap="round" />
                  <line x1="16" y1="2" x2="16" y2="6" stroke="#050b14" strokeWidth="1.8" strokeLinecap="round" />
                  <rect x="7" y="13" width="3" height="3" rx="0.5" fill="#050b14" />
                  <rect x="14" y="13" width="3" height="3" rx="0.5" fill="#050b14" />
                </svg>
              </div>
              <span className="ccta-btn-label">Book a Consultation</span>
              <svg className="ccta-btn-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M13 6l6 6-6 6" stroke="#050b14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>

            <a href="/contact" className="ccta-btn">
              <div className="ccta-btn-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" stroke="#050b14" strokeWidth="1.8" />
                  <circle cx="12" cy="9" r="2.5" stroke="#050b14" strokeWidth="1.8" />
                </svg>
              </div>
              <span className="ccta-btn-label">Request a Site Assessment</span>
              <svg className="ccta-btn-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M13 6l6 6-6 6" stroke="#050b14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </div>
        </div>

        {/* Right — headset illustration */}
        <div className="ccta-right">
          <div className="ccta-circle">
            <svg width="160" height="160" viewBox="0 0 160 160" fill="none">
              {/* Headband arc */}
              <path d="M40 90 C40 57 120 57 120 90" stroke="#1a1a1a" strokeWidth="5" strokeLinecap="round" fill="none" />
              {/* Left ear cup */}
              <rect x="28" y="86" width="20" height="28" rx="8" stroke="#1a1a1a" strokeWidth="4.5" fill="none" />
              {/* Right ear cup */}
              <rect x="112" y="86" width="20" height="28" rx="8" stroke="#1a1a1a" strokeWidth="4.5" fill="none" />
              {/* Mic arm */}
              <path d="M48 108 Q52 122 62 126" stroke="#1a1a1a" strokeWidth="4" strokeLinecap="round" fill="none" />
              {/* Mic pill */}
              <rect x="58" y="122" width="22" height="12" rx="6" stroke="#1a1a1a" strokeWidth="3.5" fill="none" />
              {/* Speech bubble */}
              <rect x="88" y="104" width="48" height="34" rx="12" fill="#eaff50" />
              <path d="M100 138 L96 148 L106 138" fill="#eaff50" />
              {/* Dots in bubble */}
              <circle cx="101" cy="121" r="3.5" fill="#1a1a1a" />
              <circle cx="112" cy="121" r="3.5" fill="#1a1a1a" />
              <circle cx="123" cy="121" r="3.5" fill="#1a1a1a" />
            </svg>
          </div>
        </div>

      </div>
    </section>
  );
}
